<app-page-shell>
    <app-page-hero eyebrow="Accounting" title="Journal Entries"
        subtitle="Review manual and system-generated ledger activity with posting status, source context, and line-level dimensions.">
        <div actions class="hero-actions">
            <p-button *ngIf="canAddJournalEntry" label="Import Entries" icon="pi pi-upload" severity="secondary" [outlined]="true" (onClick)="importJournalEntries()"></p-button>
            <p-button *ngIf="canAddJournalEntry" label="New Entry" icon="pi pi-plus" (onClick)="addJournalEntry()"></p-button>
        </div>
    </app-page-hero>

    <p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

    <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

    <app-page-data-panel title="Journal Register" subtitle="Accounting entries for the selected company"
        [resultText]="totalRequests + ' records'">
        <p-table [value]="journalEntries" dataKey="entryId" [resizableColumns]="true"
            styleClass="p-datatable-gridlines journal-table" [tableStyle]="{ 'min-width': '56rem' }"
            [paginator]="true" [rows]="rows" [first]="first" [showCurrentPageReport]="true"
            [totalRecords]="totalRequests" [lazy]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="[20, 50, 100]">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 4rem"></th>
                    <th>Entry</th>
                    <th>Context</th>
                    <th class="numeric">Amount / Status</th>
                    <th class="actions-col">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-entry let-expanded="expanded">
                <tr>
                    <td>
                        <button type="button" pButton pRipple [pRowToggler]="entry"
                            class="p-button-text p-button-rounded p-button-plain"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                            pTooltip="Toggle lines"></button>
                    </td>
                    <td>
                        <div class="cell-stack entry-cell">
                            <button type="button" class="link-button entry-number" (click)="viewJournalEntry(entry)">
                                {{ entry.entryNumber || ('JE-' + entry.entryId) }}
                            </button>
                            <span class="cell-meta">
                                <i class="pi pi-calendar"></i>
                                {{ entry.entryDate | date:'mediumDate' }}
                            </span>
                            <span class="cell-meta" *ngIf="entry.reference">
                                <i class="pi pi-hashtag"></i>
                                {{ entry.reference }}
                            </span>
                        </div>
                    </td>
                    <td>
                        <div class="cell-stack context-cell">
                            <strong>{{ entry.journal?.journalName || '-' }}</strong>
                            <span class="cell-meta">
                                <i class="pi pi-user"></i>
                                {{ entry.partnerName || entry.party?.entityName || '-' }}
                            </span>
                        </div>
                    </td>
                    <td class="numeric">
                        <div class="amount-status-stack">
                            <strong>{{ formatMoney(entry.amount, entry.currencyCode) }}</strong>
                            <p-tag [value]="displayStatus(entry)" [severity]="statusSeverity(displayStatus(entry))"></p-tag>
                        </div>
                    </td>
                    <td class="actions-col">
                        <p-button icon="pi pi-eye" severity="secondary" [text]="true" [rounded]="true"
                            pTooltip="View entry" (onClick)="viewJournalEntry(entry)"></p-button>
                        <p-button *ngIf="canEditJournalEntry" icon="pi pi-pencil" severity="info" [text]="true"
                            [rounded]="true" pTooltip="Edit entry" (onClick)="editJournalEntry(entry)"></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="expandedrow" let-entry>
                <tr>
                    <td colspan="5" class="line-expansion">
                        <p-table [value]="entry.items" dataKey="itemId" [resizableColumns]="true"
                            styleClass="p-datatable-gridlines border-1 surface-border"
                            [tableStyle]="{ 'min-width': '62rem' }">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>S#</th>
                                    <th>Account</th>
                                    <th>Party</th>
                                    <th>Description</th>
                                    <th class="numeric">Debit</th>
                                    <th class="numeric">Credit</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                                <tr>
                                    <td>{{ rowIndex + 1 }}</td>
                                    <td>{{ item.account?.accountCode }} {{ item.account?.accountName }}</td>
                                    <td>{{ item.partnerName || item.party?.entityName || '-' }}</td>
                                    <td>
                                        <div>{{ item.name || '-' }}</div>
                                        <div *ngIf="item.dimensions?.length" class="mt-2 flex flex-wrap gap-1">
                                            <p-chip *ngFor="let dim of item.dimensions"
                                                [label]="dim.dimensionType.name + ': ' + dim.dimensionValueName"
                                                styleClass="text-sm"></p-chip>
                                        </div>
                                    </td>
                                    <td class="numeric">{{ formatMoney(item.debit, entry.currencyCode) }}</td>
                                    <td class="numeric">{{ formatMoney(item.credit, entry.currencyCode) }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="6" class="empty-cell">No journal lines are available.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="5" class="empty-cell">No journal entries found.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
